import { User } from '../objects/user';
import { Version } from '../objects/version';
import { Approval } from '../objects/approval';
import { File } from '../objects/file';
import { Status } from '../objects/status';
/**
 * Updated 1st december 2023
 * Share feedback with this types:
 * - Approval 
 * - feedback (with only commnets)
 * - Upload Version (new)
 * Here we have the models  <diego@twonas.com> to 
 * fullfill the data objects managed for this features 
 */

export interface UploadVersionShare {
  origin: {
    version: Version,
    files: Array<File>,
    status: Status
  }
  upload: {
    version: Version,
    files: Array<File>
  }
}

export interface Entry {
  token: string;
  user: User;
}

/**
 * Enumeration of possible type values for version shares depending 
 * on the request mode done by user 
 *
 * @enum { string } 
 */
export enum VersionShareType {
  FEEDBACK_TYPE = "feedback", // only comments
  APPROVAL_TYPE = "approval", // approval and/or comments
  UPLOAD_VERSION_TYPE = "upload-version", // artwork request
}

/**
 * This contains the extra options needed for messages
 * @interface
 * case approval: 
 * @property message: the message leaved by the user\\
 * case upload version
 * @property version: the version string for the uploaded version
 * @property id_version: the version id for the uploaded version
 */
export interface VersionShareOptions {
  message?: string;
  id_version?: number;
  version?: string;
}
/**
 * General version share: used for fulfill the bubbles.
 * @type VersionShareType
 * @status VersionShareStatus
 * @entry Entry
 */
export interface VersionShare {
  // user?: any; in the entry
  // version?: Version; // not needed because the call is done for each version
  type: VersionShareType; // "feedback" | "approval" | "upload-version",
  status?: VersionShareStatus | null;  // be carefull in case of never null we could remove.
  entry: Entry;
  options: VersionShareOptions;
}

/**
 * Status defines depending on each VersionShare.type, the different ssituatiosn that the VersionShare
 * could have along
 */

export interface VersionShareStatus {
  date: string;
  status_code: number;  // 0: archived // 1: opened // 2: completed || approval status depending on type
  status_text?: string;
}

// For old feedbacks.
export interface VersionFeedback {
    user: User;
    version: Version;
    approval?: Approval | null;
    status?: VersionFeedbackStatus | null;  
    // optional status!!  if not, check approval & set status open.
}
// status added in 10/08/2023 to include completed status when no approval
export interface VersionFeedbackStatus {
    date: string;
    status_code: number;  // 0: archived // 1: opened // 2: completed || aapproval status depending on type
    status_text?: string;
}

export interface ShareVersionFeedback extends VersionFeedback {
  share: any;
    // TODO: share should be like
    // {date_created: string
    // entry:  
    // message: string
    // options:    {allow_see: true, get_approval: true, get_comments: true, get_signature: true}
    // owner: user}

}
/**
 * For list of shares this is the menu item model
 * 
 */

export interface VersionShareListItemMenuClick {
    key: string;
    share: VersionShare;
    menuIdentifier?: string;
}

/**
 * Enumeration of possible `CODES` and `TEXTS` for version feedbacks "particular" status
 *
 * @enum { number } 
 */
export enum FeedbackStatusCodeEnum {
  ARCHIVED_CODE = 0, // Archived
  OPENED_CODE = 1, // Opened
  CLOSED_CODE = 2, // Completed
}

export enum FeedbackStatusTextEnum {
  ARCHIVED_TEXT = 'Archived',
  OPENED_TEXT = 'Reset',
  CLOSED_TEXT = 'Completed',
}

/**
 * Enumeration of possible `CODES` for upload version status
 *
 * @enum { number } 
 */
export enum UploadVersionStatusCodeEnum {
  ARCHIVED_CODE = 0, // Archived
  OPENED_CODE = 1, // Opened
  CLOSED_CODE = 2, // Completed
}

/**
 * Enumeration of possible `CODES` and `TEXTS` for version feedback approvals status
 *
 * @enum { number } 
 */
export enum ApprovalStatusCodeEnum {
  PENDING_CODE = 0,
  APPROVED_CODE = 1,
  REJECTED_CODE = 2
}

export enum ApprovalStatusTextEnum {
  PENDING_TEXT = 'Pending',
  APPROVED_TEXT = 'Approved',
  REJECTED_TEXT = 'Rejected',
}

//*********** VersionShare.status is represented by the bubbles with colors **************/
/**
 * Array of `COLORS` for version feedback approvals status according status
 * source ['#F6B273','#47B934','#F44848'];
 *  
 */
export const ApprovalStatusColorValues: { [key: number]: string } = {
  [ApprovalStatusCodeEnum.PENDING_CODE]: '#F6B273',    // Orange for Pending
  [ApprovalStatusCodeEnum.APPROVED_CODE]: '#47B934',   // Green for Approved
  [ApprovalStatusCodeEnum.REJECTED_CODE]: '#F44848',  // Red for Rejected
};

/**
 * Array of `COLORS` for version feedback (comments only) status according status
 * source ['silver','#2E49EB'];
 *  
 */
export const FeedbackStatusColorValues: { [key: number]: string } = {
  [FeedbackStatusCodeEnum.ARCHIVED_CODE]: 'black',    // TBD for ARCHIVED (NOT USED)
  [FeedbackStatusCodeEnum.OPENED_CODE]: 'silver',   // silver grey for opened
  [FeedbackStatusCodeEnum.CLOSED_CODE]: '#2E49EB',  // blue twona for Closed/coimpleted
};
/**
 * Array of `COLORS` for version upload request status according status
 * source ['silver','#B97DE8'];
 *  
 */
export const UploadVersionStatusColorValues: { [key: number]: string } = {
  [UploadVersionStatusCodeEnum.ARCHIVED_CODE]: 'black',    // TBD for ARCHIVED (NOT USED)
  [UploadVersionStatusCodeEnum.OPENED_CODE ]: 'silver',  // silver grey for pending to upload 
  [UploadVersionStatusCodeEnum.CLOSED_CODE ]: '#B97DE8',  // purple twona for uploaded version
}

